import {Injectable} from '@angular/core';
import {Actions, createEffect, ofType} from '@ngrx/effects';
import {catchError, concatMap, map} from 'rxjs/operators';
import {of} from 'rxjs';
import {
  loadOrganizationRegions,
  loadOrganizationRegionsFailure,
  loadOrganizationRegionsSuccess
} from './organization-account.regions.actions';
import {RegionsService} from '../../../services/api/account/regions/regions.service';
import {Region} from '../../../services/api/account/regions/region.model';


@Injectable()
export class OrganizationAccountRegionsEffects {

  // noinspection JSUnusedGlobalSymbols
  loadOrganizationRegions$ = createEffect(() => {
    return this.actions$
      .pipe(
        ofType(loadOrganizationRegions),
        concatMap(() => {
            return this.service.getAll()
              .pipe(
                map((data: Region[]) => loadOrganizationRegionsSuccess({data})),
                catchError((error: any) => of(loadOrganizationRegionsFailure({error})))
              );
          }
        )
      );
  });


  constructor(
    private readonly actions$: Actions,
    private readonly service: RegionsService
  ) {
  }

}
